import bodyScrollLock from "body-scroll-lock";
let wrapper = document.querySelector('.filter__options');

export function filterMenuMobile(){
    const bodyScrollLock = require('body-scroll-lock');
    let btns = document.querySelectorAll('.show-filter-menu');

    if (!btns || !wrapper) {
        return;
    }

    btns.forEach((btn) => {
        btn.addEventListener('click', function (){
            const navigation_wrapper = document.querySelector('.filter__options');
            wrapper.classList.toggle('show');
        })
    })
}